<template>
    <div>
        <v-container fluid pa-0>
            <v-container fluid grid-list-xl class="toolbar-container">
                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                    <v-toolbar color="grey lighten-3" elevation="1">
                        <bc-btn-back></bc-btn-back>
                        <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <bc-modal-print
                            ref="print"
                            @close-method="(file_name = null), $refs.print.close()"
                            :file-name="file_name"
                            :no-button="true"
                        ></bc-modal-print>
                        <bc-btn-refresh v-if="department.department_id && department.department_id > 0" @invoke-method="dbGetDepartment(true)"></bc-btn-refresh>
                        <v-menu left content-class="no-stripe" v-if="department.department_id && department.department_id > 0">
                            <template slot="activator">
                                <v-btn icon>
                                    <v-icon>more_vert</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-tile @click="printPDF()">
                                    <v-list-tile-title> Print </v-list-tile-title>
                                </v-list-tile>
                                <template v-if="hasPerm('departments.update')">
                                    <v-divider class="ml-3 my-0"></v-divider>

                                    <div v-for="item in department_status_options" :key="item.option_id">
                                        <v-list-tile @click="changeStatus(item)" v-if="item.option_id != department.status_id">
                                            <v-list-tile-title>
                                                {{ $t(`lang.mark_as_${item.slug}`) ? $t(`lang.mark_as_${item.slug}`) : `Mark as ${item.option}` }}
                                            </v-list-tile-title>
                                        </v-list-tile>
                                    </div>
                                </template>
                                <template v-if="hasPerm('departments.delete')">
                                    <v-divider class="ml-3 my-0"></v-divider>
                                    <v-list-tile @click="$refs.delete_department.openDialog()">
                                        <v-list-tile-title> Delete </v-list-tile-title>
                                    </v-list-tile>
                                </template>
                            </v-list>
                        </v-menu>
                        <bc-tooltip>
                            <template slot="activator">
                                <v-btn icon @mouseup.left="$router.push({ name: 'departments' })">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </template>
                            {{ $t("lang.back_to_list") }}
                        </bc-tooltip>
                    </v-toolbar>
                </v-layout>
            </v-container>

            <v-card-text>
                <v-card elevation="10">
                    <v-card-text>
                        <div v-if="department.status" class="ribbon ribbon-top-right" :class="`ribbon-${department.status_class}`">
                            <span class="ribbon-span">{{ department.status }}</span>
                        </div>
                        <v-form ref="formDepartment">
                            <v-flex xs12>
                                <v-text-field
                                    v-focus="department_dialog"
                                    v-model="department.department_id"
                                    :label="$t('lang.department_id')"
                                    :counter="showCounter(department.department_id, 'departments.department_id')"
                                    :rules="ifValid('departments.department_id')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="department.department_name"
                                    :label="`${$t('lang.department_name')} *`"
                                    :counter="showCounter(department.department_name, 'departments.department_name')"
                                    :rules="ifValid('departments.department_name')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <bc-autocomplete
                                    v-model="department.manager_id"
                                    :label="$t('lang.manager_id')"
                                    :items="people"
                                    item-value="value"
                                    item-text="text"
                                    :rules="ifValid('departments.manager_id')"
                                ></bc-autocomplete>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="department.location_id"
                                    :label="$t('lang.location_id')"
                                    :counter="showCounter(department.location_id, 'departments.location_id')"
                                    :rules="ifValid('departments.location_id')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-textarea
                                    v-model="department.description"
                                    :label="$t('lang.description')"
                                    auto-grow
                                    rows="1"
                                    :rules="ifValid('departments.description')"
                                ></v-textarea>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="department.cost_center"
                                    :label="$t('lang.cost_center')"
                                    :counter="showCounter(department.cost_center, 'departments.cost_center')"
                                    :rules="ifValid('departments.cost_center')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="department.budget"
                                    :label="$t('lang.budget')"
                                    :counter="showCounter(department.budget, 'departments.budget')"
                                    :rules="ifValid('departments.budget')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <bc-date-picker
                                    v-model="department.start_date"
                                    :label="$t('lang.start_date')"
                                    :rules="ifValid('departments.start_date')"
                                ></bc-date-picker>
                            </v-flex>
                            <v-flex xs12>
                                <bc-date-picker
                                    v-model="department.end_date"
                                    :label="$t('lang.end_date')"
                                    :rules="ifValid('departments.end_date')"
                                ></bc-date-picker>
                            </v-flex>
                            <v-flex xs12>
                                <bc-autocomplete
                                    v-model="department.parent_department_id"
                                    :label="$t('lang.parent_department_id')"
                                    :items="parent_department_id"
                                    item-value="value"
                                    item-text="text"
                                    :rules="ifValid('departments.parent_department_id')"
                                ></bc-autocomplete>
                            </v-flex>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @mouseup.left="$router.push({ name: 'departments' })" flat>{{ $t("lang.cancel") }}</v-btn>
                        <v-btn color="success" @click="saveDepartments">{{ $t("lang.save") }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-card-text>

            <delete-confirmation-dialog
                ref="delete_department"
                headline="Confirm Delete?"
                :heading="$t('lang.delete_department')"
                :message="$t('lang.delete_department_confirm')"
                @onConfirm="deleteDepartments()"
            ></delete-confirmation-dialog>
            <delete-confirmation-dialog
                ref="delete_department_details"
                :heading="$t('lang.delete_package')"
                @onConfirm="confirmDeleteDepartmentDetails()"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [{ title: this.$t("lang.print"), action: "printPDF" }],

            formData: {},
            department: {},
            file_name: "",
            dbGetDepartment: _.debounce(this.getDepartment, 1500, { maxWait: 1500, leading: true, trailing: false }),
            customers: null,
            people: null,
        };
    },
    beforeRouteUpdate(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            this.$store
                .dispatch("fetchDepartment", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.department) {
                        this.department = this.assignObj2(data.department, this.rules_departments);

                        this.$store.dispatch("fetchSetting", {
                            url: "options?slug=department_status&sort_by=2",
                            method: "get",
                            stateProperty: "department_status_options",
                            dataProperty: "options",
                            commit: true,
                        });
                        this.refresh();
                        this.finishLoader();
                        next();
                    } else {
                        next({ name: "departments", replace: true });
                    }
                });
        } else {
            this.refresh();
            this.finishLoader();
            next();
        }
    },
    beforeRouteEnter(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            store
                .dispatch("fetchDepartment", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.department) {
                        next((vm) => {
                            vm.department = vm.assignObj2(data.department, vm.rules_departments);

                            store.dispatch("fetchSetting", {
                                url: "options?slug=department_status&sort_by=2",
                                method: "get",
                                stateProperty: "department_status_options",
                                dataProperty: "options",
                                commit: true,
                            });
                            vm.refresh();
                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "departments", replace: true });
                    }
                });
        } else {
            next((vm) => {
                vm.refresh();
                vm.finishLoader();
            });
        }

        /*store.dispatch("fetchSetting", {
            url: "options?slug=department_status&sort_by=2",
            method: "get",
            stateProperty: "department_status_options",
            dataProperty: "options",
            commit: true,
        });*/
    },
    computed: {
        ...mapState({
            rules_departments: (state) => state.departments.rules_departments,
            department_status_options: (state) => state.settings.department_status_options,
            departments: (state) => state.departments.departments,
            selectedDepartment: (state) => state.departments.selectedDepartment,
        }),
    },
    methods: {
        ...mapActions(["fetchDepartment", "saveDepartment", "deleteDepartment", "printDepartment"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),

        getDepartment(pg_refresh = false) {
            this.startLoader();

            this.fetchDepartment({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data !== "undefined" && data.department) {
                    this.department = this.assignObj2(data.department, this.rules_departments);
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                }
            });
        },
        printPDF() {
            this.dev_mode ? this.$refs.print.openDialog() : this.toggleGlobalSnackbar(true);

            this.printDepartment({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data != "undefined" && data.department) {
                    if (this.dev_mode) {
                        this.file_name = data.department.file_name;
                    } else {
                        this.$refs.print.printReport(data.department.file_name);
                    }

                    if (!this.dev_mode) this.toggleGlobalSnackbar(false);
                } else {
                    this.file_name = "";
                    this.$refs.print.close();
                    this.createAlert();
                }
            });
        },
        saveDepartments() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("formDepartment")) {
                    let body = this.prepForm(this.department, this.rules_departments);

                    this.saveDepartment({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.department) {
                            this.$router.push({ name: "department", params: { id: data.department.department_id } });
                        } else {
                        }
                    });
                }
            });
        },
        changeStatus(item) {
            this.status_loader = true;
            let body = { department_id: `${this.$route.params.id}`, status_id: item.option_id };

            this.saveDepartments({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.department) {
                    this.department = this.assignObj2(data.department, this.rules_departments);
                }
            });
        },
        deleteDepartments() {
            this.deleteDepartment({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.validationOff();
                    this.$router.push({ name: "departments" });
                }
                this.toggleModalLoader(false);
            });
        },
        getCustomers() {
            this.$store
                .dispatch("fetchCustomers", {
                    url: "me/companies?module=people",
                    method: "get",
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.customers = data.companies;
                    }
                });
        },
        getPeople() {
            this.startLoader();

            this.$store
                .dispatch("fetchPeople", {
                    url: "people",
                    method: "get",
                    commit: true,
                    body: {
                        slug: "employee",
                    },
                })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                    this.people = data.people;
                })
                .finally(() => {
                    this.finishLoader(false);
                });
        },
        async refresh(force = false) {
            this.startLoader();

            if (force == true) {
                await this.fetchDepartment({
                    id: `${this.$route.params.id}`,
                }).then((data) => {
                    if (typeof data !== "undefined" && data.department) {
                        this.department = this.assignObj2(data.department, this.rules_departments);
                        this.toggleModalLoader(false);
                        this.validationOff();
                        this.finishLoader(true);
                    }
                });
            } else {
                this.finishLoader();
            }

            if (this.people == null || force == true) this.getPeople();
        },
    },
    created() {},
};
</script>
